import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  BillingFrequency,
  useGetPackagePriceMap_package$key,
} from "./__generated__/useGetPackagePriceMap_package.graphql";

export const useGetPackagePriceMap = (
  packageRef: useGetPackagePriceMap_package$key | undefined | null
) => {
  const pkg = useFragment(useGetPackagePriceMapFragmentString, packageRef);

  const pricingMap = pkg?.billingOptions?.reduce((map, option) => {
    option?.billingCharges?.forEach((charge) => {
      if (
        charge?.frequency &&
        charge?.squareVariation?.amount !== undefined &&
        charge?.squareVariation?.amount !== null
      ) {
        if (map[charge.frequency] === undefined) {
          map[charge.frequency] = charge.squareVariation.amount;
        } else {
          map[charge.frequency] =
            map[charge.frequency] + charge.squareVariation.amount;
        }
      }
    });
    return map;
  }, {} as Record<BillingFrequency, number>);

  return pricingMap;
};

const useGetPackagePriceMapFragmentString = graphql`
  fragment useGetPackagePriceMap_package on Package {
    billingOptions {
      billingCharges {
        frequency
        squareVariation {
          amount
        }
      }
    }
  }
`;
